import React from 'react';
import { Heart, Mail, Phone, MapPin } from 'lucide-react';

const CONTACT_INFO = {
  email: 'sebastianrodriguezpsa@gmail.com',
  phone: '+54-380-4379609',
  location: 'Argentina',
};

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-sky-400 to-sky-600 rounded-full flex items-center justify-center text-white font-bold text-xl">
                FD
              </div>
              <div>
                <h3 className="text-white font-bold text-lg">FUNDACIÓN</h3>
                <p className="text-sky-400 text-sm font-semibold">FUTUROS DEL DEPORTE</p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Transformando jóvenes talentos del interior argentino en atletas profesionales y de elite.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('mision')}
                  className="hover:text-sky-400 transition-colors"
                >
                  Misión y Visión
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('programas')}
                  className="hover:text-sky-400 transition-colors"
                >
                  Programas
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('impacto')}
                  className="hover:text-sky-400 transition-colors"
                >
                  Nuestro Impacto
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('colaborar')}
                  className="hover:text-sky-400 transition-colors"
                >
                  Cómo Colaborar
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-sky-400" />
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  className="hover:text-sky-400 transition-colors"
                >
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-sky-400" />
                <a
                  href={`tel:${CONTACT_INFO.phone}`}
                  className="hover:text-sky-400 transition-colors"
                >
                  {CONTACT_INFO.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <MapPin className="w-5 h-5 text-sky-400" />
                <span>{CONTACT_INFO.location}</span>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Apoyo</h4>
            <p className="text-gray-400 mb-4">
              Cada colaboración cuenta. Su empresa puede cambiar vidas.
            </p>
            <button
              onClick={() => scrollToSection('contacto')}
              className="bg-sky-600 hover:bg-sky-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors inline-flex items-center space-x-2"
            >
              <Heart className="w-5 h-5" />
              <span>Colaborar Ahora</span>
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Fundación Futuros del Deporte. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-6 text-sm">
              <button className="hover:text-sky-400 transition-colors">Política de Privacidad</button>
              <button className="hover:text-sky-400 transition-colors">Términos de Uso</button>
              <button className="hover:text-sky-400 transition-colors">Transparencia</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
